import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import { Loader2, CheckCircle2 } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const AgentAccept = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const token = params.get('token') || '';
  const org = params.get('org') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/agencies/accept-invite`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, org, password }),
      });
      const d = await r.json();
      if (!r.ok || !d.success) throw new Error(d.message || 'Could not set your password.');
      // Auto sign-in
      const { error: err } = await supabase.auth.signInWithPassword({ email: email.trim().toLowerCase(), password });
      if (err) { setDone(true); return; }
      navigate('/agent');
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  const invalid = !email || !token || !org;

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg,#0A1A33 0%,#0f2547 100%)' }} data-testid="agent-accept-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <span className="text-2xl font-extrabold text-slate-900">Jobasti<span className="text-blue-600">IQ</span></span>
        {invalid ? (
          <p className="text-sm text-red-600 mt-4" data-testid="agent-accept-invalid">This invite link is invalid or incomplete. Please use the link from your email.</p>
        ) : done ? (
          <div className="mt-4 text-center">
            <CheckCircle2 className="w-10 h-10 text-green-500 mx-auto mb-2" />
            <p className="text-sm text-slate-600">Password set! You can now <a href="/agent/login" className="text-blue-600 font-medium">sign in</a>.</p>
          </div>
        ) : (
          <>
            <p className="text-sm text-slate-500 mt-1 mb-5">Welcome! Set a password for <b>{email}</b> to access your agent portal.</p>
            <form onSubmit={submit} className="space-y-4">
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 chars)" className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="agent-accept-password" required />
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="agent-accept-confirm" required />
              {error && <p className="text-sm text-red-600" data-testid="agent-accept-error">{error}</p>}
              <button type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2" data-testid="agent-accept-submit">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} Set password & continue
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default AgentAccept;
